import { QuebecOperationTaxes } from '../operation-taxes'

export const OperationTaxes = {
  ...QuebecOperationTaxes,
} as const
